import { BackupCheckStatus } from "@/constants/entity-status";
import { AppColors } from "@/styles/colors";
import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import { PenLine, Printer, X } from "lucide-react";
import { BackupCheckTransferredAmountCard } from "./BackupCheckTransferredAmountCard";

interface Props {
  amount?: number;
  status?: BackupCheckStatus;
  handlePrint?: () => void;
  handleCancel?: () => void;
  handleOpenEditNumber?: () => void;
  handleFinalize?: () => void;
  loadingPrint?: boolean;
  loadingFinalize?: boolean;
}

export const BackupCheckAmountAndActions = ({
  amount,
  status,
  handlePrint,
  handleCancel,
  handleOpenEditNumber,
  handleFinalize,
  loadingPrint,
  loadingFinalize,
}: Props) => {
  const hideActions =
    status === BackupCheckStatus.CANCELLED ||
    status === BackupCheckStatus.FINISHED;

  const isPendingEndose = status === BackupCheckStatus.PENDING_ENDOSE;
  const isPendingCheck = status === BackupCheckStatus.PENDING_CHECK;

  return (
    <Flex justifyContent="space-between" gap="12px">
      <BackupCheckTransferredAmountCard amount={amount} />

      {!hideActions && (
        <HStack gap="12px" alignItems="flex-start">
          {isPendingEndose && (
            <>
              <Button
                paddingX="12px"
                height="32px"
                onClick={handleOpenEditNumber}
                loading={loadingPrint}
                disabled={loadingPrint || loadingFinalize}
                data-testid="backup-check-edit-number-btn"
                variant="outline"
                borderColor={AppColors.LIGHT_GREEN_TEXT}
              >
                <PenLine color={AppColors.LIGHT_GREEN_TEXT} />
                <Text
                  fontWeight={600}
                  fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
                  color={AppColors.LIGHT_GREEN_TEXT}
                >
                  Editar N° de Cheque
                </Text>
              </Button>

              <Button
                paddingX="12px"
                height="32px"
                bgColor={AppColors.GREEN_PRIMARY}
                onClick={handleFinalize}
                loading={loadingFinalize}
                disabled={loadingPrint || loadingFinalize}
                data-testid="backup-check-finalize-btn"
              >
                <Text
                  fontWeight={600}
                  fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
                >
                  Finalizar
                </Text>
              </Button>
            </>
          )}

          {isPendingCheck && (
            <>
              <Button
                paddingX="12px"
                height="32px"
                bgColor={AppColors.GREEN_PRIMARY}
                onClick={handlePrint}
                data-testid="backup-check-print-btn"
              >
                <Printer />
                <Text
                  fontWeight={600}
                  fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
                >
                  Imprimir
                </Text>
              </Button>
              <Button
                paddingX="12px"
                height="32px"
                bgColor={AppColors.RED_ICON}
                onClick={handleCancel}
                data-testid="backup-check-cancel-btn"
              >
                <X />
                <Text
                  fontWeight={600}
                  fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
                >
                  Cancelar
                </Text>
              </Button>
            </>
          )}
        </HStack>
      )}
    </Flex>
  );
};
